function VerifiedIconJobDetails() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_5394)">
        <path
          d="M26.849 6.88497L15.5122 0.140537C15.1971 -0.0468457 14.8047 -0.0468457 14.4897 0.140537L3.15279 6.88497C2.8498 7.06526 2.66406 7.39186 2.66406 7.74442V11.5944C2.66406 19.7035 7.34922 27.1098 14.6399 29.9325C14.872 30.0224 15.1296 30.0225 15.362 29.9325C22.6349 27.1169 27.3377 19.7266 27.3377 11.5944V7.74442C27.3378 7.39181 27.1521 7.06526 26.849 6.88497ZM19.9414 12.7529L13.6739 19.0204C13.2834 19.411 12.6502 19.411 12.2597 19.0204L10.0601 16.8209C9.66953 16.4304 9.66953 15.7972 10.0601 15.4067C10.4506 15.0162 11.0838 15.0162 11.4743 15.4067L12.9667 16.8991L18.5271 11.3387C18.9176 10.9482 19.5508 10.9482 19.9414 11.3387C20.332 11.7293 20.332 12.3624 19.9414 12.7529Z"
          fill="#0278FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_5394">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default VerifiedIconJobDetails;
